import api from './axios';
import { InventoryMovement } from '../types';

export const inventoryApi = {
  getAll: (params?: { type?: string; startDate?: string; endDate?: string; productId?: number }) =>
    api.get<InventoryMovement[]>('/inventory/movements', { params }),

  create: (data: { productId: number; type: string; quantity: number; reason: string }) =>
    api.post<InventoryMovement>('/inventory/movements', data),

  getByProduct: (productId: number) =>
    api.get<InventoryMovement[]>(`/inventory/movements/product/${productId}`),

  createEntrada: (data: any) => api.post('/inventory/entrada', data),
  createSalida: (data: any) => api.post('/inventory/salida', data),
  createAjuste: (data: any) => api.post('/inventory/ajuste', data),
  createIngresoMercaderia: (data: any) => api.post('/inventory/ingreso-mercaderia', data),
  getKardex: (productId: number) => api.get(`/inventory/kardex/${productId}`),
};
